<template>
  <div>
        <div v-loading="$store.getters.getLoadingState" style="display: flex; flex-direction: column; justify-content: space-between; align-items: space-between; width: 100%;">
            
            <div style="display: flex; flex-direction: column; margin-top: -40px; text-align: left;">
                <span>
                    {{$store.getters.getSaleMasterDataProps.sale_number_prefix}}{{$store.getters.getSaleMasterDataProps.sale_number}}
                </span>
                <span>
                    {{$store.getters.getCustomerMasterDataProps.customer_name}}, {{$store.getters.getUserGroupAlerts.hide_critical_customer_info ? '' : $store.getters.getCustomerMasterDataProps.primary_mobile_number_calling_code}}-{{$store.getters.getCustomerMasterDataProps.primary_mobile_number}}
                </span>
                <div style="display: flex; flex-direction: row; margin-top: 20px;" v-if="calendar_source && isSalesEditAllowed">
                    <span style="margin-top: 5px;">
                        Delivery Date
                    </span>
                    <el-date-picker
                        size="small"
                        type="date"
                        :disabled="$store.getters.getPreferenceProps.disable_back_dated_entry"
                        v-model="$store.state.saleMaster.props.delivery_date"
                        style="width: 200px; margin-left: 10px;" 
                        value-format="yyyy-MM-dd"
                        format="MMM dd yyyy">
                    </el-date-picker>
                    <el-button @click="updateSalesDeliveryDate" size="small" type="primary" style="margin-left: 10px;">
                        Ok
                    </el-button>
                </div>
                <div style="display: flex; flex-direction: row; margin-top: 20px;" v-if="calendar_source && $store.getters.getSaleMasterDataProps.trial_required && isSalesEditAllowed">
                    <span style="margin-top: 5px;">
                        Trial Date
                    </span>
                    <el-date-picker
                        size="small"
                        type="date"
                        :disabled="$store.getters.getPreferenceProps.disable_back_dated_entry"
                        v-model="$store.state.saleMaster.props.trial_date"
                        style="width: 200px; margin-left: 10px;" 
                        value-format="yyyy-MM-dd"
                        format="MMM dd yyyy">
                    </el-date-picker>
                    <el-button @click="updateSalesTrialDate" size="small" type="primary" style="margin-left: 10px;">
                        Ok
                    </el-button>
                </div>
            </div>

            <el-tabs style="margin-top: 20px;" v-model="activeTab">
                <el-tab-pane :label="'Order List'" name="1">
                    <OrderList :quickView="true" />
                </el-tab-pane>
                <el-tab-pane v-if="$store.getters.getSaleMasterDataProps.id>0" :label="'Payment History'" name="2">
                    <CustomerPaymentList
                        :popup="true"
                        :readonly="true"
                        :source_id="$store.getters.getInventoryInvoiceDataProps.id"/>
                </el-tab-pane>
                <el-tab-pane v-if="$store.getters.getSaleMasterDataProps.id>0" :label="'Production Status'" name="3">
                    <ProductionList
                        :quickView="true"
                        :allow_delivery="false"
                        :calendar_source="calendar_source"
                        :payroll="payroll"
                        :sale_id="$store.getters.getSaleMasterDataProps.id"/>
                </el-tab-pane>
                <el-tab-pane v-if="$store.getters.getSaleMasterDataProps.id>0" :label="'Group Production Status'" name="4">
                    <GroupProductionStatus :data_list="$store.getters.getProductionWorkOrderAutocompleteList"/>
                </el-tab-pane>
            </el-tabs>
            
        </div>

  </div>
</template>

<script>
import OrderList from '../Form/OrderItem/OrderList.vue'
import ProductionList from '../../WorkOrder/ProductionList.vue'
import CustomerPaymentList from '../../CustomerPayment/Index.vue'
import GroupProductionStatus from './GroupProductionStatus.vue'

export default {
    components: {OrderList, ProductionList, CustomerPaymentList, GroupProductionStatus},
    props: ['sale_id', 'calendar_source', 'selected_date', 'store_id', 'payroll'],
    data() {
        return {
            activeTab: '1'
        }
    },
    computed: {
        isSalesEditAllowed() {
            return this.checkIfModuleAccessAvailable('/salesorders', 'can_edit')
        }
    },
    methods: {
        async updateSalesDeliveryDate() {
            await this.$store.dispatch('updateSalesDeliveryDate', {data: this.$store.getters.getSaleMasterDataProps, selected_date: this.selected_date, store_id: this.store_id})

            setTimeout(() => {
                this.$emit('closed')
            }, 1000);
        },
        async updateSalesTrialDate() {
            await this.$store.dispatch('updateSalesTrialDate', {data: this.$store.getters.getSaleMasterDataProps, selected_date: this.selected_date, store_id: this.store_id})

            setTimeout(() => {
                this.$emit('closed')
            }, 1000);
        }
    },
    mounted() {
        this.$store.dispatch('fetchSaleMasterData', {id: this.sale_id, fabricPriceSlabExists: this.$store.getters.getFabricPriceSlabList.length>0})     
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/SaleMaster/QuickDetail/Index.vue